// apps/web/hooks/maincontent/useResponseHandling.ts
import { useEffect } from 'react';

import { ChatConversation } from '../../types/chat-completion.type';
import { splitTextByPattern } from '../../utils/activities';
import { setResponsePopulated } from '../../utils/responsePopulatedUtil';

interface UseResponseHandlingProps {
  conversation: ChatConversation;
  lessonPlanContent: string | undefined;
  aiResponseText: string;
  setResponseToShow: (response: string) => void;
  responseToShow: string;
  lessonFormat?: string;
}

export function useResponseHandling({
  conversation,
  lessonPlanContent,
  aiResponseText,
  setResponseToShow,
  responseToShow,
  lessonFormat,
}: UseResponseHandlingProps): void {
  useEffect(() => {
    if (conversation?.messages?.length === 1) {
      setResponseToShow(aiResponseText);
    } else if (lessonPlanContent && conversation?.messages?.length > 1) {
      const content = splitTextByPattern(lessonPlanContent, lessonFormat);
      setResponseToShow(
        `${content.beginning}\n\n${aiResponseText}\n\n${content.end}`,
      );
    }
  }, [
    aiResponseText,
    conversation?.messages?.length,
    lessonPlanContent,
    setResponseToShow,
    lessonFormat,
  ]);

  useEffect(() => {
    setResponsePopulated(!!responseToShow);
  }, [responseToShow]);
}
